import findAppendix from './findAppendix';
import { isTruthy } from '../../Helpers';

/**
 * @function formatIncome - Formats numbers into income friendly values (100,000) => $100K
 * @param {number} value
 * @param {string} currencySign
 * @return {string} Formatted income string
 * @example formatIncome(1000) => $1K
 */
const formatIncome = (value, currencySign = '$') => {
  if (!isTruthy(value)) return '$0';

  const withDecimals = value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  const withoutDecimals = withDecimals.slice(0, withDecimals.indexOf('.'));
  const withoutCommas = withoutDecimals.slice(0, withoutDecimals.indexOf(','));
  const appendix = findAppendix(withoutDecimals);

  return isTruthy(appendix) ?
    `${currencySign}${withoutCommas}${findAppendix(withoutDecimals)}` :
    `${currencySign}${withoutDecimals}`;
};

export default formatIncome;
